<template>
  <form @submit="onFormSubmit">
    <TextInputFormField
      label="Email Address"
      class="mb-4"
      name="email"
      type="email"
    />
    <ActionButtonPrimary
      type="submit"
      :is-loading="isSubmitting"
      class="w-full"
    >
      Send Receipt
    </ActionButtonPrimary>
  </form>
</template>

<script setup lang="ts">
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import { sendOrderReceipt } from "@/services/orders/sendOrderReceipt"
import { sendTransactionReceipt } from "@/services/transactions/sendTransactionReceipt"
import z from "zod"
import { emailAddressSchema } from "@/forms/validation/stringFieldSchemas"

const props = defineProps<{
  objectId: string
  receiptType: "order" | "transaction"
}>()

const emit = defineEmits<{
  (eventName: "submit-success"): void
}>()

const formSchema = z.object({
  email: emailAddressSchema(
    "Please enter an email address"
  ),
})

const { handleSubmit, isSubmitting } = useForm({
  validationSchema: toTypedSchema(formSchema),
  initialValues: { email: "" },
})

const onFormSubmit = handleSubmit(async (formValues) => {
  try {
    props.receiptType === "order"
      ? await sendOrderReceipt(props.objectId, formValues)
      : await sendTransactionReceipt(
          props.objectId,
          formValues
        )
    toast.success(`Receipt sent to ${formValues.email}`)
    emit("submit-success")
  } catch {
    toast.error("Failed to send receipt")
  }
})
</script>
